const HEARTLAND_TOS_URL = 'https://www.heartland.us/terms';
const HEARTLAND_PRIVACY_URL = 'https://www.heartland.us/privacy-policy';
const HEARTLAND_GOOGLE_PRIVACY_POLICY_URL = 'https://policies.google.com/privacy';
const HEARTLAND_GOOGLE_TREMS_SERVICE_URL = 'https://policies.google.com/terms';

export { HEARTLAND_TOS_URL as H, HEARTLAND_PRIVACY_URL as a, HEARTLAND_GOOGLE_PRIVACY_POLICY_URL as b, HEARTLAND_GOOGLE_TREMS_SERVICE_URL as c };
